import * as i0 from '@angular/core';
import { Component, Input, NgModule, EventEmitter, Directive, Output, HostListener, Inject, Pipe, InjectionToken, forwardRef, Injectable, ViewEncapsulation } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i1$1 from 'angular-l10n';
import { L10N_LOCALE, L10nTranslationModule } from 'angular-l10n';
import * as i1 from 'primeng/overlaypanel';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import * as i3 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i4 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';
import { Subject, tap, catchError, of, combineLatest, startWith, debounceTime, map, debounce, timer, distinctUntilChanged, filter, switchMap, take } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import * as i1$2 from '@angular/platform-browser';
import _Inputmask from 'inputmask';
import * as i1$3 from 'primeng/calendar';
import { CalendarModule } from 'primeng/calendar';
import * as i4$1 from '@angular/forms';
import { DefaultValueAccessor, NG_VALUE_ACCESSOR, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import * as i1$4 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { SubSink } from 'subsink';
import { __awaiter, __rest } from 'tslib';
import * as i2$1 from 'primeng/autocomplete';
import { AutoCompleteModule } from 'primeng/autocomplete';
import * as i3$1 from 'primeng/inputmask';
import { InputMaskModule } from 'primeng/inputmask';
import * as i6 from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import * as i2$2 from 'primeng/dialog';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import * as i2$3 from 'ngx-cookie';

class SubDividerComponent {
    constructor() { }
}
SubDividerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SubDividerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SubDividerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: SubDividerComponent, selector: "lib-sub-divider", inputs: { title: "title" }, ngImport: i0, template: "\n<div class=\"row divider\">\n    {{ title }}\n    <ng-content select=\"[preview]\"></ng-content>\n</div>\n<div class=\"form-container\">\n    <ng-content select=\"[subBody]\"></ng-content>\n</div>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SubDividerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-sub-divider', template: "\n<div class=\"row divider\">\n    {{ title }}\n    <ng-content select=\"[preview]\"></ng-content>\n</div>\n<div class=\"form-container\">\n    <ng-content select=\"[subBody]\"></ng-content>\n</div>", styles: [""] }]
        }], ctorParameters: function () { return []; }, propDecorators: { title: [{
                type: Input
            }] } });

class SubDividerModule {
}
SubDividerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SubDividerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SubDividerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SubDividerModule, declarations: [SubDividerComponent], imports: [CommonModule], exports: [SubDividerComponent] });
SubDividerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SubDividerModule, imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SubDividerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SubDividerComponent],
                    exports: [SubDividerComponent],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

class PreventDoubleClicksDirective {
    constructor() {
        this.throttleTime = 1000;
        this.preventDoubleClicks = new EventEmitter();
        this.clicks = new Subject();
    }
    ngOnInit() {
        this.subscription = this.clicks.pipe(throttleTime(this.throttleTime))
            .subscribe(e => this.emitThrottledClick(e));
    }
    emitThrottledClick(e) {
        this.preventDoubleClicks.emit(e);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    clickEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    }
}
PreventDoubleClicksDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PreventDoubleClicksDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
PreventDoubleClicksDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: PreventDoubleClicksDirective, selector: "[libPreventDoubleClicks]", inputs: { throttleTime: "throttleTime" }, outputs: { preventDoubleClicks: "preventDoubleClicks" }, host: { listeners: { "click": "clickEvent($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PreventDoubleClicksDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[libPreventDoubleClicks]'
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { throttleTime: [{
                type: Input
            }], preventDoubleClicks: [{
                type: Output
            }], clickEvent: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class DataTableComponent {
    constructor(locale) {
        this.locale = locale;
        this.labelScope = '';
        this.showRowNumber = false;
        this.selectedRowHighlight = -1;
        this.disableEdit = false;
        this.disableDelete = false;
        this.deleteEvent = new EventEmitter();
        this.editEvent = new EventEmitter();
    }
    selectSubTable(event, row, overlayPanel) {
        this.selectedRow = row.subRowData;
        overlayPanel.toggle(event);
    }
    triggerEditEvent(id) {
        this.editEvent.emit(id);
    }
    triggerDeleteEvent(id) {
        this.deleteEvent.emit(id);
    }
}
DataTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DataTableComponent, deps: [{ token: L10N_LOCALE }], target: i0.ɵɵFactoryTarget.Component });
DataTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DataTableComponent, selector: "lib-data-table", inputs: { headerDefinition: "headerDefinition", rowData: "rowData", subHeaderDefinition: "subHeaderDefinition", labelScope: "labelScope", showRowNumber: "showRowNumber", selectedRowHighlight: "selectedRowHighlight", previewMode: "previewMode", disableEdit: "disableEdit", disableDelete: "disableDelete", customViewLabel: "customViewLabel" }, outputs: { deleteEvent: "deleteEvent", editEvent: "editEvent" }, ngImport: i0, template: "<ng-container *ngIf=\"rowData && headerDefinition\">\n    <div class=\"table-responsive-sm\">\n       <table class=\"table table-sm table-bordered\">\n        <caption></caption>\n        <thead>\n          <tr>\n            <th *ngIf=\"subHeaderDefinition && !previewMode\" id=\"optional-column\">{{(customViewLabel ? customViewLabel : \"\")}}</th>\n            <th *ngIf=\"showRowNumber\">{{ ( labelScope ? labelScope + '.ITEM' : 'Item' ) | translate: locale.language }}</th>\n            <th *ngFor=\"let col of headerDefinition; let i = index\" [id]=\"'main-' + i\">\n              {{ col?.header }}\n            </th>\n            <th *ngIf=\"!previewMode || (disableDelete && disableEdit)\" id=\"action\">{{ ( labelScope ? labelScope + '.SELECT_ACTION' : 'SELECT_ACTION' ) | translate: locale.language }}</th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let row of rowData; let i = index\">\n            <tr [ngClass]=\"{'row-error': row.isError, 'selected': i === selectedRowHighlight}\">\n              <td *ngIf=\"subHeaderDefinition && !previewMode\">\n                <span class=\"ButtonContainer\">\n                  <button type=\"button\" pButton pTooltip=\"{{ (labelScope ? labelScope +  '.VIEW' : 'VIEW') | translate: locale.language }}\" [attr.aria-label]=\"(labelScope ? labelScope +  '.VIEW' : 'VIEW') | translate: locale.language\" tooltipPosition=\"bottom\" (click)=\"selectSubTable($event, row, op)\" icon=\"pi pi-eye\"></button>\n                </span>\n              </td>\n              <td *ngIf=\"showRowNumber\"> #{{ i + 1 }} </td>\n              <td *ngFor=\"let col of headerDefinition\">\n                {{ row[col.field] }}\n              </td>\n              <td *ngIf=\"!previewMode\">\n                <span class=\"ButtonContainer\">\n                  <button\n                    *ngIf=\"!disableEdit && !row['singleRowEditDisable']\"\n                    pButton\n                    libPreventDoubleClicks\n                    tooltipPosition=\"bottom\"\n                    pTooltip=\"{{ (labelScope ? labelScope + '.EDIT' : 'EDIT') | translate: locale.language }}\"\n                    [attr.aria-label]=\"(labelScope ? labelScope + '.EDIT' : 'EDIT') | translate: locale.language\"\n                    [icon]=\"'pi pi-pencil'\"\n                    (preventDoubleClicks)=\"triggerEditEvent(row.id)\">\n                  </button>\n                  <button\n                    *ngIf=\"!disableDelete && !row['singleRowDeleteDisable']\"\n                    pButton\n                    libPreventDoubleClicks\n                    tooltipPosition=\"bottom\"\n                    pTooltip=\"{{ (labelScope ? labelScope + '.DELETE' : 'DELETE') | translate: locale.language }}\"\n                    [attr.aria-label]=\"(labelScope ? labelScope + '.DELETE' : 'DELETE') | translate: locale.language\"\n                    [icon]=\"'pi pi-trash'\"\n                    (preventDoubleClicks)=\"triggerDeleteEvent(row.id)\">\n                  </button>\n                </span>\n              </td>\n            </tr>\n            <ng-container *ngIf=\"(row.subRowData?.length > 0) && previewMode\"\n              [ngTemplateOutlet]=\"previewSubTable\"\n              [ngTemplateOutletContext]=\"{subRowData: row.subRowData, headerDefinition: headerDefinition, showRowNumber: showRowNumber}\"\n            ></ng-container>\n          </ng-container>\n        </tbody>\n      </table>\n    </div>\n  </ng-container>\n  <p-overlayPanel #op [showCloseIcon]=\"true\" [dismissable]=\"false\" styleClass=\"close-icon-ls\">\n    <div class=\"table-responsive-sm\" *ngIf=\"subHeaderDefinition\">\n      <table class=\"table table-sm table-bordered\">\n        <caption></caption>\n        <thead>\n          <tr>\n            <th *ngIf=\"showRowNumber\">{{ ( labelScope ? labelScope + '.ITEM' : 'Item' ) | translate: locale.language }}</th>\n            <th *ngFor=\"let col of subHeaderDefinition; let i = index\" [id]=\"'sub-' + i\">\n              {{ col?.header }}\n            </th>\n          </tr>\n        </thead>\n        <tbody *ngIf=\"selectedRow\">\n          <tr *ngFor=\"let row of selectedRow; let i = index\">\n            <td *ngIf=\"showRowNumber\"> #{{ i }} </td>\n            <td *ngFor=\"let col of subHeaderDefinition\">\n              {{ row[col.field] }}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </p-overlayPanel>\n\n  <ng-template #previewSubTable let-subRowData=\"subRowData\" let-headerDefinition=\"headerDefinition\" let-showRowNumber=\"showRowNumber\">\n    <tr *ngFor=\"let row of subRowData; let i = index\">\n      <td *ngIf=\"showRowNumber\"></td>\n      <td *ngFor=\"let col of headerDefinition\">\n        {{ subRowData[i][col.field] }}\n      </td>\n    </tr>\n  </ng-template>\n\n", styles: [".ButtonContainer{display:flex}.ButtonContainer button{margin:0 5px;font-size:.7rem}.table-bordered td,.table-bordered th{vertical-align:middle}@media (max-width: 575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-sm>.table-bordered{border:0}}.table{width:100%;margin-bottom:1rem;color:#212529}.table th,.table td{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table-sm th,.table-sm td{padding:.3rem}.table-bordered,.table-bordered th,.table-bordered td{border:1px solid #dee2e6}.table-bordered thead th,.table-bordered thead td{border-bottom-width:2px}.row-error{color:#c81414}@keyframes selected{0%{background-color:#ffecac}to{background-color:inherit}}.selected{animation:selected linear 1.3s infinite alternate}\n"], components: [{ type: i1.OverlayPanel, selector: "p-overlayPanel", inputs: ["dismissable", "showCloseIcon", "style", "styleClass", "appendTo", "autoZIndex", "ariaCloseLabel", "baseZIndex", "focusOnShow", "showTransitionOptions", "hideTransitionOptions"], outputs: ["onShow", "onHide"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading"] }, { type: i4.Tooltip, selector: "[pTooltip]", inputs: ["tooltipPosition", "tooltipEvent", "appendTo", "positionStyle", "tooltipStyleClass", "tooltipZIndex", "escape", "showDelay", "hideDelay", "life", "positionTop", "positionLeft", "pTooltip", "tooltipDisabled", "tooltipOptions"] }, { type: PreventDoubleClicksDirective, selector: "[libPreventDoubleClicks]", inputs: ["throttleTime"], outputs: ["preventDoubleClicks"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "translate": i1$1.L10nTranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DataTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-data-table', template: "<ng-container *ngIf=\"rowData && headerDefinition\">\n    <div class=\"table-responsive-sm\">\n       <table class=\"table table-sm table-bordered\">\n        <caption></caption>\n        <thead>\n          <tr>\n            <th *ngIf=\"subHeaderDefinition && !previewMode\" id=\"optional-column\">{{(customViewLabel ? customViewLabel : \"\")}}</th>\n            <th *ngIf=\"showRowNumber\">{{ ( labelScope ? labelScope + '.ITEM' : 'Item' ) | translate: locale.language }}</th>\n            <th *ngFor=\"let col of headerDefinition; let i = index\" [id]=\"'main-' + i\">\n              {{ col?.header }}\n            </th>\n            <th *ngIf=\"!previewMode || (disableDelete && disableEdit)\" id=\"action\">{{ ( labelScope ? labelScope + '.SELECT_ACTION' : 'SELECT_ACTION' ) | translate: locale.language }}</th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let row of rowData; let i = index\">\n            <tr [ngClass]=\"{'row-error': row.isError, 'selected': i === selectedRowHighlight}\">\n              <td *ngIf=\"subHeaderDefinition && !previewMode\">\n                <span class=\"ButtonContainer\">\n                  <button type=\"button\" pButton pTooltip=\"{{ (labelScope ? labelScope +  '.VIEW' : 'VIEW') | translate: locale.language }}\" [attr.aria-label]=\"(labelScope ? labelScope +  '.VIEW' : 'VIEW') | translate: locale.language\" tooltipPosition=\"bottom\" (click)=\"selectSubTable($event, row, op)\" icon=\"pi pi-eye\"></button>\n                </span>\n              </td>\n              <td *ngIf=\"showRowNumber\"> #{{ i + 1 }} </td>\n              <td *ngFor=\"let col of headerDefinition\">\n                {{ row[col.field] }}\n              </td>\n              <td *ngIf=\"!previewMode\">\n                <span class=\"ButtonContainer\">\n                  <button\n                    *ngIf=\"!disableEdit && !row['singleRowEditDisable']\"\n                    pButton\n                    libPreventDoubleClicks\n                    tooltipPosition=\"bottom\"\n                    pTooltip=\"{{ (labelScope ? labelScope + '.EDIT' : 'EDIT') | translate: locale.language }}\"\n                    [attr.aria-label]=\"(labelScope ? labelScope + '.EDIT' : 'EDIT') | translate: locale.language\"\n                    [icon]=\"'pi pi-pencil'\"\n                    (preventDoubleClicks)=\"triggerEditEvent(row.id)\">\n                  </button>\n                  <button\n                    *ngIf=\"!disableDelete && !row['singleRowDeleteDisable']\"\n                    pButton\n                    libPreventDoubleClicks\n                    tooltipPosition=\"bottom\"\n                    pTooltip=\"{{ (labelScope ? labelScope + '.DELETE' : 'DELETE') | translate: locale.language }}\"\n                    [attr.aria-label]=\"(labelScope ? labelScope + '.DELETE' : 'DELETE') | translate: locale.language\"\n                    [icon]=\"'pi pi-trash'\"\n                    (preventDoubleClicks)=\"triggerDeleteEvent(row.id)\">\n                  </button>\n                </span>\n              </td>\n            </tr>\n            <ng-container *ngIf=\"(row.subRowData?.length > 0) && previewMode\"\n              [ngTemplateOutlet]=\"previewSubTable\"\n              [ngTemplateOutletContext]=\"{subRowData: row.subRowData, headerDefinition: headerDefinition, showRowNumber: showRowNumber}\"\n            ></ng-container>\n          </ng-container>\n        </tbody>\n      </table>\n    </div>\n  </ng-container>\n  <p-overlayPanel #op [showCloseIcon]=\"true\" [dismissable]=\"false\" styleClass=\"close-icon-ls\">\n    <div class=\"table-responsive-sm\" *ngIf=\"subHeaderDefinition\">\n      <table class=\"table table-sm table-bordered\">\n        <caption></caption>\n        <thead>\n          <tr>\n            <th *ngIf=\"showRowNumber\">{{ ( labelScope ? labelScope + '.ITEM' : 'Item' ) | translate: locale.language }}</th>\n            <th *ngFor=\"let col of subHeaderDefinition; let i = index\" [id]=\"'sub-' + i\">\n              {{ col?.header }}\n            </th>\n          </tr>\n        </thead>\n        <tbody *ngIf=\"selectedRow\">\n          <tr *ngFor=\"let row of selectedRow; let i = index\">\n            <td *ngIf=\"showRowNumber\"> #{{ i }} </td>\n            <td *ngFor=\"let col of subHeaderDefinition\">\n              {{ row[col.field] }}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </p-overlayPanel>\n\n  <ng-template #previewSubTable let-subRowData=\"subRowData\" let-headerDefinition=\"headerDefinition\" let-showRowNumber=\"showRowNumber\">\n    <tr *ngFor=\"let row of subRowData; let i = index\">\n      <td *ngIf=\"showRowNumber\"></td>\n      <td *ngFor=\"let col of headerDefinition\">\n        {{ subRowData[i][col.field] }}\n      </td>\n    </tr>\n  </ng-template>\n\n", styles: [".ButtonContainer{display:flex}.ButtonContainer button{margin:0 5px;font-size:.7rem}.table-bordered td,.table-bordered th{vertical-align:middle}@media (max-width: 575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-sm>.table-bordered{border:0}}.table{width:100%;margin-bottom:1rem;color:#212529}.table th,.table td{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table-sm th,.table-sm td{padding:.3rem}.table-bordered,.table-bordered th,.table-bordered td{border:1px solid #dee2e6}.table-bordered thead th,.table-bordered thead td{border-bottom-width:2px}.row-error{color:#c81414}@keyframes selected{0%{background-color:#ffecac}to{background-color:inherit}}.selected{animation:selected linear 1.3s infinite alternate}\n"] }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [L10N_LOCALE]
                    }] }];
    }, propDecorators: { headerDefinition: [{
                type: Input
            }], rowData: [{
                type: Input
            }], subHeaderDefinition: [{
                type: Input
            }], labelScope: [{
                type: Input
            }], showRowNumber: [{
                type: Input
            }], selectedRowHighlight: [{
                type: Input
            }], previewMode: [{
                type: Input
            }], disableEdit: [{
                type: Input
            }], disableDelete: [{
                type: Input
            }], customViewLabel: [{
                type: Input
            }], deleteEvent: [{
                type: Output
            }], editEvent: [{
                type: Output
            }] } });

class ClearNullPipe {
    transform(value) {
        return value === null ? '' : value;
    }
}
ClearNullPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ClearNullPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ClearNullPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ClearNullPipe, name: "clearNull" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ClearNullPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'clearNull'
                }]
        }] });

class SafeHtmlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
SafeHtmlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SafeHtmlPipe, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafeHtmlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SafeHtmlPipe, name: "safeHtml" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SafeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safeHtml'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }]; } });

class ReplacePipe {
    transform(value, params) {
        const replacedValue = value.replace(/{{\s?([^{}\s]*)\s?}}/g, (substring, parsedKey) => {
            const replacer = params[parsedKey];
            return replacer !== undefined ? replacer : substring;
        });
        return replacedValue;
    }
}
ReplacePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ReplacePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ReplacePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ReplacePipe, name: "replace" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ReplacePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'replace'
                }]
        }] });

const DYNAMIC_L10N_API_ENDPOINT = new InjectionToken('TRANSLATION-END-POINT');
const UI_LABEL_PREFIX = new InjectionToken('');

class YNtoStringPipe {
    constructor(prefix, locale, translator) {
        this.prefix = prefix;
        this.locale = locale;
        this.translator = translator;
    }
    transform(value, locale = this.locale.language) {
        let anwser = '';
        if (typeof value === 'string') {
            if (value === 'true') {
                anwser = this.prefix ? this.translator.translate(`${this.prefix}.YES`) : 'Yes';
            }
            else if (value === 'false') {
                anwser = this.prefix ? this.translator.translate(`${this.prefix}.NO`) : 'No';
            }
        }
        else if (typeof value === 'boolean') {
            if (value) {
                anwser = this.prefix ? this.translator.translate(`${this.prefix}.YES`) : 'Yes';
            }
            else if (!value) {
                anwser = this.prefix ? this.translator.translate(`${this.prefix}.NO`) : 'No';
            }
        }
        return anwser;
    }
}
YNtoStringPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: YNtoStringPipe, deps: [{ token: UI_LABEL_PREFIX }, { token: L10N_LOCALE }, { token: i1$1.L10nTranslationService }], target: i0.ɵɵFactoryTarget.Pipe });
YNtoStringPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: YNtoStringPipe, name: "yNtoString" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: YNtoStringPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'yNtoString'
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [UI_LABEL_PREFIX]
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [L10N_LOCALE]
                    }] }, { type: i1$1.L10nTranslationService }];
    } });

class AddressToStringPipe {
    transform(address) {
        let singleAddresString;
        if (address.streetAddress2) {
            singleAddresString = `${address.streetAddress1}, ${address.streetAddress2}, ${address.city}, ${address.state}, ${address.zip}`;
        }
        else {
            singleAddresString = `${address.streetAddress1}, ${address.city}, ${address.state}, ${address.zip}`;
        }
        return singleAddresString;
    }
}
AddressToStringPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AddressToStringPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
AddressToStringPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AddressToStringPipe, name: "addressToString" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AddressToStringPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'addressToString'
                }]
        }] });

class ProperNamePipe {
    transform(fullName) {
        let name = '';
        if (fullName.firstName && fullName.lastName && !fullName.middleName) {
            name = fullName.firstName + ' ' + fullName.lastName;
        }
        else if (fullName.middleName) {
            name = fullName.firstName + ' ' + fullName.middleName + ' ' + fullName.lastName;
        }
        if (fullName.suffix) {
            name += ' ' + fullName.suffix;
        }
        return name;
    }
}
ProperNamePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ProperNamePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ProperNamePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ProperNamePipe, name: "properName" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ProperNamePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'properName'
                }]
        }] });

const Inputmask = _Inputmask.default || _Inputmask;
class DateMaskDirective {
    constructor(primeCalendar) {
        this.primeCalendar = primeCalendar;
    }
    ngAfterViewInit() {
        new Inputmask(this.getDateMask()).mask(this.getHTMLInput());
    }
    getHTMLInput() {
        return this.primeCalendar.el.nativeElement.querySelector('input');
    }
    getDateMask() {
        if (this.primeCalendar.timeOnly) {
            return '99:99';
        }
        else if (this.primeCalendar.showTime) {
            return '99/99/9999 99:99';
        }
        else {
            return '99/99/9999';
        }
    }
}
DateMaskDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DateMaskDirective, deps: [{ token: i1$3.Calendar }], target: i0.ɵɵFactoryTarget.Directive });
DateMaskDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DateMaskDirective, selector: "[dateMask]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DateMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dateMask]'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.Calendar }]; } });

class ForceUppercaseDirective extends DefaultValueAccessor {
    constructor(renderer, elementRef) {
        super(renderer, elementRef, false);
    }
    input($event) {
        const target = $event.target;
        const start = target.selectionStart;
        target.value = target.value.toUpperCase();
        target.setSelectionRange(start, start);
        this.onChange(target.value);
    }
}
ForceUppercaseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ForceUppercaseDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ForceUppercaseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: ForceUppercaseDirective, selector: "input[libToUppercase]", host: { listeners: { "input": "input($event)" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => ForceUppercaseDirective),
        }
    ], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ForceUppercaseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[libToUppercase]',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: forwardRef(() => ForceUppercaseDirective),
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { input: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });

class GlobalUtilitiesModule {
}
GlobalUtilitiesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: GlobalUtilitiesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GlobalUtilitiesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: GlobalUtilitiesModule, declarations: [ClearNullPipe,
        SafeHtmlPipe,
        PreventDoubleClicksDirective,
        ReplacePipe,
        YNtoStringPipe,
        AddressToStringPipe,
        ProperNamePipe,
        DateMaskDirective,
        ForceUppercaseDirective], imports: [CommonModule,
        CalendarModule,
        L10nTranslationModule], exports: [ClearNullPipe,
        SafeHtmlPipe,
        PreventDoubleClicksDirective,
        ReplacePipe,
        YNtoStringPipe,
        AddressToStringPipe,
        ProperNamePipe,
        DateMaskDirective,
        ForceUppercaseDirective] });
GlobalUtilitiesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: GlobalUtilitiesModule, imports: [[
            CommonModule,
            CalendarModule,
            L10nTranslationModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: GlobalUtilitiesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ClearNullPipe,
                        SafeHtmlPipe,
                        PreventDoubleClicksDirective,
                        ReplacePipe,
                        YNtoStringPipe,
                        AddressToStringPipe,
                        ProperNamePipe,
                        DateMaskDirective,
                        ForceUppercaseDirective,
                    ],
                    imports: [
                        CommonModule,
                        CalendarModule,
                        L10nTranslationModule
                    ],
                    exports: [
                        ClearNullPipe,
                        SafeHtmlPipe,
                        PreventDoubleClicksDirective,
                        ReplacePipe,
                        YNtoStringPipe,
                        AddressToStringPipe,
                        ProperNamePipe,
                        DateMaskDirective,
                        ForceUppercaseDirective,
                    ]
                }]
        }] });

class DataTableModule {
}
DataTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DataTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DataTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DataTableModule, declarations: [DataTableComponent], imports: [CommonModule,
        ButtonModule,
        TooltipModule,
        OverlayPanelModule,
        L10nTranslationModule,
        GlobalUtilitiesModule], exports: [DataTableComponent] });
DataTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DataTableModule, imports: [[
            CommonModule,
            ButtonModule,
            TooltipModule,
            OverlayPanelModule,
            L10nTranslationModule,
            GlobalUtilitiesModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DataTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DataTableComponent
                    ],
                    exports: [DataTableComponent],
                    imports: [
                        CommonModule,
                        ButtonModule,
                        TooltipModule,
                        OverlayPanelModule,
                        L10nTranslationModule,
                        GlobalUtilitiesModule
                    ]
                }]
        }] });

const lib_i18nAssets = {
    'en-US': {
        SELECT_ACTION: 'Select',
        VIEW: 'View',
        EDIT: 'Edit',
        DELETE: 'Delete',
        "CA_LABEL": {
            YES: "Yes",
            NO: "No"
        }
    },
    'en-CA': {
        SELECT_ACTION: 'ca-Select',
        VIEW: 'ca-View',
        EDIT: 'ca-Edit',
        DELETE: 'ca-Delete',
        "CA_LABEL": {
            YES: "Yes",
            NO: "No"
        }
    },
    'fr-CA': {
        "CA_LABEL": {
            YES: "Oui",
            NO: "Noun"
        },
        SELECT_ACTION: 'fr - Select',
        VIEW: 'fr - View',
        EDIT: 'fr - Edit',
        DELETE: 'fr - Delete',
    }
};

class RetrieveTranslate {
    constructor(http, dynamic_token) {
        this.http = http;
        this.dynamic_token = dynamic_token;
        this.translationObject = {};
        this._translationsLoaded$ = new Subject();
    }
    getTranslation(ui) {
        return this.http
            .get(this.dynamic_token + ui)
            .pipe(tap((data) => {
            for (let entry of data.result) {
                if (this.translationObject.hasOwnProperty(entry.locale)) {
                    this.translationObject[entry.locale][entry.displayKey] =
                        entry.displayValue;
                }
                else {
                    this.translationObject[entry.locale] = {};
                    this.translationObject[entry.locale][entry.displayKey] =
                        entry.displayValue;
                }
            }
            this._translationsLoaded$.next();
        }), catchError((err) => {
            console.log(err);
            this.translationObject = {};
            return of(null);
        }));
    }
    getValue(key, locale) {
        if (this.translationObject.hasOwnProperty(locale)) {
            return this.translationObject[locale][key];
        }
        else {
            return null;
        }
    }
    get translationsLoaded$() {
        return this._translationsLoaded$.asObservable();
    }
}
RetrieveTranslate.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: RetrieveTranslate, deps: [{ token: i1$4.HttpClient }, { token: DYNAMIC_L10N_API_ENDPOINT }], target: i0.ɵɵFactoryTarget.Injectable });
RetrieveTranslate.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: RetrieveTranslate, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: RetrieveTranslate, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: i1$4.HttpClient }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [DYNAMIC_L10N_API_ENDPOINT]
                    }] }];
    } });

class kvTranslate {
    constructor(retrieveTranslate) {
        this.retrieveTranslate = retrieveTranslate;
    }
    transform(value, locale) {
        var result = this.retrieveTranslate.getValue(value, locale);
        if (result != null) {
            return result;
        }
        else {
            return value;
        }
    }
}
kvTranslate.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: kvTranslate, deps: [{ token: RetrieveTranslate }], target: i0.ɵɵFactoryTarget.Pipe });
kvTranslate.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: kvTranslate, name: "kvTranslate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: kvTranslate, decorators: [{
            type: Pipe,
            args: [{
                    name: 'kvTranslate',
                }]
        }], ctorParameters: function () { return [{ type: RetrieveTranslate }]; } });

class TranslateTxtInputDirective {
    constructor(locale, el, control, kvTranslate, retrieveTranslate, translations) {
        this.locale = locale;
        this.el = el;
        this.control = control;
        this.kvTranslate = kvTranslate;
        this.retrieveTranslate = retrieveTranslate;
        this.translations = translations;
        this.overrideDelay = 500;
        this.disableTranslation = false;
        this.sub = new SubSink();
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    ngOnInit() {
        var _a;
        this.loadTranslatedValue(this.control.value);
        this.retrieveTranslate.translationsLoaded$.subscribe(() => this.loadTranslatedValue(this.control.value));
        if ((_a = this.control) === null || _a === void 0 ? void 0 : _a.valueChanges) {
            this.sub.sink = combineLatest([this.control.valueChanges.pipe(startWith(this.control.value)), this.translations.onChange()])
                .pipe(debounceTime(this.overrideDelay))
                .subscribe(([value, locale]) => {
                this.loadTranslatedValue(value, locale.language);
            });
        }
    }
    loadTranslatedValue(value, language) {
        let lang = language || this.locale.language;
        this.el.nativeElement.value = this.disableTranslation ? value : this.kvTranslate.transform(value, lang);
    }
}
TranslateTxtInputDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TranslateTxtInputDirective, deps: [{ token: L10N_LOCALE }, { token: i0.ElementRef }, { token: i4$1.NgControl }, { token: kvTranslate }, { token: RetrieveTranslate }, { token: i1$1.L10nTranslationService }], target: i0.ɵɵFactoryTarget.Directive });
TranslateTxtInputDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: TranslateTxtInputDirective, selector: "[libTranslateTxtInput]", inputs: { overrideDelay: "overrideDelay", disableTranslation: "disableTranslation" }, providers: [kvTranslate], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TranslateTxtInputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[libTranslateTxtInput]',
                    providers: [kvTranslate]
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [L10N_LOCALE]
                    }] }, { type: i0.ElementRef }, { type: i4$1.NgControl }, { type: kvTranslate }, { type: RetrieveTranslate }, { type: i1$1.L10nTranslationService }];
    }, propDecorators: { overrideDelay: [{
                type: Input
            }], disableTranslation: [{
                type: Input
            }] } });

class L10nStorageService {
    constructor() {
        this.hasStorage = typeof Storage !== 'undefined';
    }
    read() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.hasStorage) {
                let locale = sessionStorage.getItem('locale');
                if (null != locale) {
                    return Promise.resolve(JSON.parse(locale));
                }
            }
            return Promise.resolve(null);
        });
    }
    write(locale) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.hasStorage) {
                sessionStorage.setItem('locale', JSON.stringify(locale));
            }
        });
    }
}
L10nStorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: L10nStorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
L10nStorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: L10nStorageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: L10nStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class DynamicTranslationModule {
}
DynamicTranslationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicTranslationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DynamicTranslationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicTranslationModule, declarations: [kvTranslate,
        TranslateTxtInputDirective], imports: [CommonModule,
        L10nTranslationModule], exports: [kvTranslate,
        TranslateTxtInputDirective] });
DynamicTranslationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicTranslationModule, imports: [[
            CommonModule,
            L10nTranslationModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicTranslationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        kvTranslate,
                        TranslateTxtInputDirective
                    ],
                    imports: [
                        CommonModule,
                        L10nTranslationModule
                    ],
                    exports: [
                        kvTranslate,
                        TranslateTxtInputDirective
                    ]
                }]
        }] });

const ADDRESS_ENDPOINT = new InjectionToken('ADDRESS-END-POINT');

class SmartAddressService {
    constructor(httpClient, addressUrl) {
        this.httpClient = httpClient;
        this.addressUrl = addressUrl;
    }
    getAddressSuggestions(freeFormText, countryCode) {
        var addressLookUpDTO = {
            freeFormTxt: freeFormText,
            countryCd: countryCode,
            biasedStateSortKey: 'PA'
        };
        return this.httpClient.post(this.addressUrl, addressLookUpDTO)
            .pipe(map(response => {
            if (response.error) {
                //TODO handle error based on messages
                return [];
            }
            if (null != response['result'] && response['result'].length > 0) {
                return response['result'].map((address) => {
                    return {
                        streetAddress1: address['streetAddress1'],
                        streetAddress2: address['streetAddress2'],
                        city: address['city'],
                        state: address['state'],
                        country: address['country'],
                        zip: address['postalCode']
                    };
                });
            }
            return [];
        }), catchError(err => {
            return of([]);
        }));
    }
}
SmartAddressService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressService, deps: [{ token: i1$4.HttpClient }, { token: ADDRESS_ENDPOINT }], target: i0.ɵɵFactoryTarget.Injectable });
SmartAddressService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressService, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: i1$4.HttpClient }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [ADDRESS_ENDPOINT]
                    }] }];
    } });

class SmartAddressComponent {
    constructor(locale, smartAddressService) {
        this.locale = locale;
        this.smartAddressService = smartAddressService;
        this.zipSub = new SubSink();
        this.debounceTimer = 500;
        this.minLength = 5;
        this.cacheTTL = 300000;
        this.stateList = [];
        this.showEmptyMessage = true;
        this.unmask = false;
        this.results$ = of([]);
        this.requiredMap = {
            streetAddress1: false,
            streetAddress2: false,
            city: false,
            state: false,
            zip: false
        };
        this.cache = {};
        this.debounceEnable = false;
        this.addressEntry ? this.addressEntry : new FormControl('');
    }
    // @ViewChild('zip') zipInputMask!: InputMask;
    set addressForm(form) {
        var _a;
        this._addressForm = form;
        this.addressEntry = this._addressForm.get('streetAddress1');
        this.searchAddress();
        Object.keys(this.requiredMap).forEach(formname => {
            var _a;
            this.requiredMap[formname] = ((_a = this._addressForm.get(formname)) === null || _a === void 0 ? void 0 : _a.hasValidator(Validators.required)) ? true : false;
        });
        this.zipSub.sink = (_a = this._addressForm.get('zip')) === null || _a === void 0 ? void 0 : _a.valueChanges.pipe(debounceTime(500)).subscribe(zip => {
            var _a;
            if (zip && zip.replace('_', '').length === this.zipCodePattern.length) {
                (_a = this._addressForm.get('zip')) === null || _a === void 0 ? void 0 : _a.setValue(zip.toUpperCase(), { emitEvent: false });
            }
        });
    }
    searchAddress() {
        let indexSearchValue;
        this.results$ = this.addressEntry.valueChanges.pipe(debounce(() => this.debounceEnable ? timer(this.debounceTimer) : timer(this.debounceTimer * 0)), distinctUntilChanged(), filter((searchValue) => typeof searchValue === 'string' && searchValue.trim().length >= this.minLength), tap(() => {
            this.debounceEnable = true;
            if (!this.cacheTimeout || this.cacheTimeout + this.cacheTTL <= new Date().getTime()) {
                this.cacheTimeout = new Date().getTime();
                this.cache = {};
            }
        }), switchMap(searchValueTrimmed => {
            if (this.cache[searchValueTrimmed] === undefined) {
                indexSearchValue = searchValueTrimmed;
                return this.smartAddressService.getAddressSuggestions(searchValueTrimmed, this.countryCode);
            }
            return of([...this.cache[searchValueTrimmed]]);
        }), tap(result => {
            if (this.cache[indexSearchValue] === undefined) {
                this.cache[indexSearchValue] = result;
            }
        }));
    }
    patchValue(address) {
        let { streetAddress1 } = address, restAddress = __rest(address, ["streetAddress1"]);
        this.addressEntry.setValue(streetAddress1, {
            emitEvent: false
        });
        this._addressForm.patchValue(Object.assign({}, restAddress));
    }
    enableAddressDetails() {
        Object.entries(this.requiredMap).forEach(([key, _]) => {
            var _a;
            (_a = this._addressForm.get(key)) === null || _a === void 0 ? void 0 : _a.enable();
        });
    }
    disableAddressDetails(clearValues) {
        Object.entries(this.requiredMap).forEach(([key, _]) => {
            var _a, _b;
            if (key !== 'streetAddress1') {
                (_a = this._addressForm.get(key)) === null || _a === void 0 ? void 0 : _a.disable();
                if (clearValues) {
                    (_b = this._addressForm.get(key)) === null || _b === void 0 ? void 0 : _b.setValue('', {
                        emitEvent: false
                    });
                }
            }
        });
    }
}
SmartAddressComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressComponent, deps: [{ token: L10N_LOCALE }, { token: SmartAddressService }], target: i0.ɵɵFactoryTarget.Component });
SmartAddressComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: SmartAddressComponent, selector: "lib-smart-address", inputs: { addressForm: "addressForm", debounceTimer: "debounceTimer", minLength: "minLength", cacheTTL: "cacheTTL", componentId: "componentId", countryCode: "countryCode", zipCodePattern: "zipCodePattern", stateList: "stateList", showEmptyMessage: "showEmptyMessage", unmask: "unmask" }, ngImport: i0, template: "\n\n<ng-container>\n  <div [formGroup]=\"_addressForm\" class=\"row\">\n\n    <div class=\"form-group col-auto\">\n        <label [for]=\"'streetAddress1' + componentId\"><span class=\"required\" *ngIf=\"requiredMap['streetAddress1']\">* </span>{{ 'CA_LABEL.STREETADDRESS1' | translate: locale.language }}</label>\n        <br>\n        <p-autoComplete [style]=\"{ 'display': 'block'}\" name=\"streetAddress1\" inputStyleClass=\"form-control\" [inputId]=\"'streetAddress1' + componentId\" [formControl]=\"addressEntry\" [showEmptyMessage]=\"showEmptyMessage\" [suggestions]=\"(results$ | async) || []\" placeholder=\"{{ 'CA_LABEL.ENTER_ADDRESS' | translate: locale.language }}\" (onSelect)=\"patchValue($event)\">\n          <ng-template let-addr pTemplate=\"item\">\n            {{ addr | addressToString }}\n          </ng-template>\n        </p-autoComplete>\n        <ng-content select=\"[streetAddress1]\"></ng-content>\n    </div>\n\n    <div class=\"form-group col-2\">\n      <label [for]=\"'streetAddress2' + componentId\"><span class=\"required\" *ngIf=\"requiredMap['streetAddress2']\">* </span>{{ 'CA_LABEL.STREETADDRESS2' | translate: locale.language}}</label>\n      <input formControlName=\"streetAddress2\" type=\"text\" [id]=\"'streetAddress2' + componentId\" class=\"form-control\">\n      <ng-content select=\"[streetAddress2]\"></ng-content>\n    </div>\n  </div>\n  <div [formGroup]=\"_addressForm\" class=\"row\">\n    <div class=\"form-group col-2\">\n      <label [for]=\"'city' + componentId\"><span class=\"required\" *ngIf=\"requiredMap['city']\">* </span>{{ 'CA_LABEL.CITY' | translate: locale.language}}</label>\n      <input formControlName=\"city\" type=\"text\" [id]=\"'city' + componentId\" class=\"form-control\">\n      <ng-content select=\"[city]\"></ng-content>\n    </div>\n    <div class=\"form-group col-2\">\n      <label [for]=\"'state' + componentId\"><span class=\"required\" *ngIf=\"requiredMap['state']\">* </span>{{ 'CA_LABEL.STATE' | translate: locale.language}}</label>\n      <ng-container *ngIf=\"stateList.length > 0; else manualInput\">\n        <select [id]=\"'state' + componentId\" formControlName=\"state\" class=\"form-control\" >\n          <option value=\"\" readonly=\"true\">{{'PLEASE_SELECT' | translate: locale.language}}</option>\n          <option *ngFor=\"let state of stateList\" [value]=\"state\">{{state | kvTranslate:locale.language}}</option>\n        </select>\n      </ng-container>\n      <ng-template #manualInput>\n      <input formControlName=\"state\" type=\"text\" [id]=\"'state' + componentId\" class=\"form-control\">\n    </ng-template>\n    <ng-content select=\"[state]\"></ng-content>\n    </div>\n\n    <div class=\"form-group col-2\">\n      <label [for]=\"'zip' + componentId\"><span class=\"required\" *ngIf=\"requiredMap['zip']\">* </span>{{ 'CA_LABEL.ZIP' | translate: locale.language}}</label>\n      <p-inputMask #zip formControlName=\"zip\" styleClass=\"form-control\" [style]=\"{'text-transform': 'uppercase'}\" [mask]=\"zipCodePattern\" [id]=\"'zip' + componentId\" [autoClear]=\"false\" [unmask]=\"unmask\"></p-inputMask>\n      <ng-content select=\"[zip]\"></ng-content>\n\n    </div>\n  </div>\n</ng-container>\n\n\n\n", styles: [""], components: [{ type: i2$1.AutoComplete, selector: "p-autoComplete", inputs: ["minLength", "delay", "style", "panelStyle", "styleClass", "panelStyleClass", "inputStyle", "inputId", "inputStyleClass", "placeholder", "readonly", "disabled", "virtualScroll", "itemSize", "maxlength", "name", "required", "size", "appendTo", "autoHighlight", "forceSelection", "type", "autoZIndex", "baseZIndex", "ariaLabel", "dropdownAriaLabel", "ariaLabelledBy", "dropdownIcon", "unique", "group", "completeOnFocus", "showClear", "field", "scrollHeight", "dropdown", "showEmptyMessage", "dropdownMode", "multiple", "tabindex", "dataKey", "emptyMessage", "showTransitionOptions", "hideTransitionOptions", "autofocus", "autocomplete", "optionGroupChildren", "optionGroupLabel", "suggestions"], outputs: ["completeMethod", "onSelect", "onUnselect", "onFocus", "onBlur", "onDropdownClick", "onClear", "onKeyUp", "onShow", "onHide"] }, { type: i3$1.InputMask, selector: "p-inputMask", inputs: ["type", "slotChar", "autoClear", "showClear", "style", "inputId", "styleClass", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "disabled", "readonly", "unmask", "name", "required", "characterPattern", "autoFocus", "autocomplete", "mask"], outputs: ["onComplete", "onFocus", "onBlur", "onInput", "onKeydown", "onClear"] }], directives: [{ type: i4$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i4$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i4$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i6.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { type: i4$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i4$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i4$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i4$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i4$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i1$1.L10nTranslatePipe, "async": i2.AsyncPipe, "addressToString": AddressToStringPipe, "kvTranslate": kvTranslate } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-smart-address', template: "\n\n<ng-container>\n  <div [formGroup]=\"_addressForm\" class=\"row\">\n\n    <div class=\"form-group col-auto\">\n        <label [for]=\"'streetAddress1' + componentId\"><span class=\"required\" *ngIf=\"requiredMap['streetAddress1']\">* </span>{{ 'CA_LABEL.STREETADDRESS1' | translate: locale.language }}</label>\n        <br>\n        <p-autoComplete [style]=\"{ 'display': 'block'}\" name=\"streetAddress1\" inputStyleClass=\"form-control\" [inputId]=\"'streetAddress1' + componentId\" [formControl]=\"addressEntry\" [showEmptyMessage]=\"showEmptyMessage\" [suggestions]=\"(results$ | async) || []\" placeholder=\"{{ 'CA_LABEL.ENTER_ADDRESS' | translate: locale.language }}\" (onSelect)=\"patchValue($event)\">\n          <ng-template let-addr pTemplate=\"item\">\n            {{ addr | addressToString }}\n          </ng-template>\n        </p-autoComplete>\n        <ng-content select=\"[streetAddress1]\"></ng-content>\n    </div>\n\n    <div class=\"form-group col-2\">\n      <label [for]=\"'streetAddress2' + componentId\"><span class=\"required\" *ngIf=\"requiredMap['streetAddress2']\">* </span>{{ 'CA_LABEL.STREETADDRESS2' | translate: locale.language}}</label>\n      <input formControlName=\"streetAddress2\" type=\"text\" [id]=\"'streetAddress2' + componentId\" class=\"form-control\">\n      <ng-content select=\"[streetAddress2]\"></ng-content>\n    </div>\n  </div>\n  <div [formGroup]=\"_addressForm\" class=\"row\">\n    <div class=\"form-group col-2\">\n      <label [for]=\"'city' + componentId\"><span class=\"required\" *ngIf=\"requiredMap['city']\">* </span>{{ 'CA_LABEL.CITY' | translate: locale.language}}</label>\n      <input formControlName=\"city\" type=\"text\" [id]=\"'city' + componentId\" class=\"form-control\">\n      <ng-content select=\"[city]\"></ng-content>\n    </div>\n    <div class=\"form-group col-2\">\n      <label [for]=\"'state' + componentId\"><span class=\"required\" *ngIf=\"requiredMap['state']\">* </span>{{ 'CA_LABEL.STATE' | translate: locale.language}}</label>\n      <ng-container *ngIf=\"stateList.length > 0; else manualInput\">\n        <select [id]=\"'state' + componentId\" formControlName=\"state\" class=\"form-control\" >\n          <option value=\"\" readonly=\"true\">{{'PLEASE_SELECT' | translate: locale.language}}</option>\n          <option *ngFor=\"let state of stateList\" [value]=\"state\">{{state | kvTranslate:locale.language}}</option>\n        </select>\n      </ng-container>\n      <ng-template #manualInput>\n      <input formControlName=\"state\" type=\"text\" [id]=\"'state' + componentId\" class=\"form-control\">\n    </ng-template>\n    <ng-content select=\"[state]\"></ng-content>\n    </div>\n\n    <div class=\"form-group col-2\">\n      <label [for]=\"'zip' + componentId\"><span class=\"required\" *ngIf=\"requiredMap['zip']\">* </span>{{ 'CA_LABEL.ZIP' | translate: locale.language}}</label>\n      <p-inputMask #zip formControlName=\"zip\" styleClass=\"form-control\" [style]=\"{'text-transform': 'uppercase'}\" [mask]=\"zipCodePattern\" [id]=\"'zip' + componentId\" [autoClear]=\"false\" [unmask]=\"unmask\"></p-inputMask>\n      <ng-content select=\"[zip]\"></ng-content>\n\n    </div>\n  </div>\n</ng-container>\n\n\n\n", styles: [""] }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [L10N_LOCALE]
                    }] }, { type: SmartAddressService }];
    }, propDecorators: { addressForm: [{
                type: Input
            }], debounceTimer: [{
                type: Input
            }], minLength: [{
                type: Input
            }], cacheTTL: [{
                type: Input
            }], componentId: [{
                type: Input
            }], countryCode: [{
                type: Input
            }], zipCodePattern: [{
                type: Input
            }], stateList: [{
                type: Input
            }], showEmptyMessage: [{
                type: Input
            }], unmask: [{
                type: Input
            }] } });

class SmartAddressModule {
    static forRoot(addressUrl) {
        return {
            ngModule: SmartAddressModule,
            providers: [
                {
                    provide: ADDRESS_ENDPOINT,
                    useValue: addressUrl
                }
            ]
        };
    }
}
SmartAddressModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SmartAddressModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressModule, declarations: [SmartAddressComponent], imports: [CommonModule,
        AutoCompleteModule,
        ReactiveFormsModule,
        L10nTranslationModule,
        HttpClientModule,
        InputMaskModule,
        DynamicTranslationModule,
        GlobalUtilitiesModule], exports: [SmartAddressComponent] });
SmartAddressModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressModule, providers: [
        SmartAddressService
    ], imports: [[
            CommonModule,
            AutoCompleteModule,
            ReactiveFormsModule,
            L10nTranslationModule,
            HttpClientModule,
            InputMaskModule,
            DynamicTranslationModule,
            GlobalUtilitiesModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SmartAddressComponent
                    ],
                    imports: [
                        CommonModule,
                        AutoCompleteModule,
                        ReactiveFormsModule,
                        L10nTranslationModule,
                        HttpClientModule,
                        InputMaskModule,
                        DynamicTranslationModule,
                        GlobalUtilitiesModule
                    ],
                    providers: [
                        SmartAddressService
                    ],
                    exports: [
                        SmartAddressComponent
                    ]
                }]
        }] });

/**
 * Implement the class for Smart Address to Work
 */
class SmartAddressServiceAbstract {
}
SmartAddressServiceAbstract.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressServiceAbstract, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SmartAddressServiceAbstract.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressServiceAbstract });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SmartAddressServiceAbstract, decorators: [{
            type: Injectable
        }] });

class NotificationPopUpService {
    constructor() {
        this._notificationMessage$ = new Subject();
        this._response$ = new Subject();
    }
    get notificationMessage$() {
        return this._notificationMessage$.asObservable();
    }
    sendNotificationMessage(message) {
        let singleSubject = new Subject();
        this._notificationMessage$.next([message, singleSubject]);
        return singleSubject.asObservable().pipe(take(1));
    }
}
NotificationPopUpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NotificationPopUpService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NotificationPopUpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NotificationPopUpService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NotificationPopUpService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class NotificationPopUpComponent {
    constructor(notificationMsgService) {
        this.notificationMsgService = notificationMsgService;
        this.sub = new SubSink();
        this.popUpData = null;
        this.holdSubject = null;
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    ngOnInit() {
        this.sub.sink = this.notificationMsgService.notificationMessage$.subscribe(([msg, subject]) => {
            if (msg.logOffTimer) {
                this.startTimerMsg(msg, subject);
            }
            else {
                this.popUpData = msg;
                this.holdSubject = subject;
            }
        });
    }
    buttonAction(confirmType) {
        let tempData = this.popUpData;
        let tempSubject = this.holdSubject;
        this.popUpData = null;
        this.holdSubject = null;
        tempSubject === null || tempSubject === void 0 ? void 0 : tempSubject.next([confirmType, tempData === null || tempData === void 0 ? void 0 : tempData.data]);
    }
    startTimerMsg(msg, subject) {
        // this.timerMsg = msg;
        // this.countDown = new Date().getTime() + (60 * 65 * 1000);
        // this.currentTime = new Date().getTime();
        // this.confirmObj = this.confirmationService.confirm({
        //   key: 'idleTimer',
        //   header: msg.header,
        //   message: msg.content,
        //   acceptLabel: msg.acceptMessage,
        //   rejectLabel: msg.declineMessage,
        //   accept: () => {
        //     subject.next([ConfirmEventType.ACCEPT, msg.data]);
        //   },
        //   reject: (type: ConfirmEventType) => {
        //     subject.next([type, msg.data]);
        //   }
        // })
        // this.timer = setInterval(() => {
        //   if (this.countDown <= this.currentTime) {
        //     clearInterval(this.timer);
        //     subject.next([ConfirmEventType.REJECT, this.timerMsg.data]);
        //     this.confirmObj?.close();
        //     this.confirmObj = undefined;
        //   }
        //   this.currentTime = new Date().getTime();
        // }, 1000)
    }
}
NotificationPopUpComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NotificationPopUpComponent, deps: [{ token: NotificationPopUpService }], target: i0.ɵɵFactoryTarget.Component });
NotificationPopUpComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: NotificationPopUpComponent, selector: "lib-notification-pop-up", providers: [ConfirmationService], ngImport: i0, template: "<p-dialog [style]=\"{ width: '400px' }\" *ngIf=\"popUpData\" [resizable]=\"false\" [draggable]=\"false\" [visible]=\"popUpData\" [closeOnEscape]=\"false\" [closable]=\"false\" (onHide)=\"buttonAction(2)\">\n  <ng-template pTemplate=\"header\">\n    {{ popUpData.header }}\n  </ng-template>\n\n  <p>{{ popUpData.content }}</p>\n\n\n  <ng-template pTemplate=\"footer\">\n    <ng-container *ngIf=\"popUpData.declineMessage\">\n      <button class=\"whitebutton\" (click)=\"buttonAction(1)\">{{popUpData.declineMessage}}</button>\n    </ng-container>\n    <ng-container *ngIf=\"popUpData.acceptMessage\">\n      <button class=\"btn btn-primary\" (click)=\"buttonAction(0)\">{{popUpData.acceptMessage}}</button>\n    </ng-container>\n  </ng-template>\n\n</p-dialog>\n\n<!-- <p-dialog key=\"idleTimer\" [style]=\"{ width:'400px' }\">\n\n  <ng-template pTemplate=\"content\">\n    <p>{{ timerMsg.data?.sessionActive | replace:{time: (countDown - currentTime) | date:'mm:ss' } }}</p>\n    <p></p>\n  </ng-template>\n\n\n</p-dialog> -->\n", styles: ["p-confirmdialog .p-button-icon.p-button-icon-left.pi{display:none}\n"], components: [{ type: i2$2.Dialog, selector: "p-dialog", inputs: ["header", "draggable", "resizable", "positionLeft", "positionTop", "contentStyle", "contentStyleClass", "modal", "closeOnEscape", "dismissableMask", "rtl", "closable", "responsive", "appendTo", "breakpoints", "styleClass", "maskStyleClass", "showHeader", "breakpoint", "blockScroll", "autoZIndex", "baseZIndex", "minX", "minY", "focusOnShow", "maximizable", "keepInViewport", "focusTrap", "transitionOptions", "closeIcon", "closeAriaLabel", "closeTabindex", "minimizeIcon", "maximizeIcon", "visible", "style", "position"], outputs: ["onShow", "onHide", "visibleChange", "onResizeInit", "onResizeEnd", "onDragEnd", "onMaximize"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NotificationPopUpComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-notification-pop-up', providers: [ConfirmationService], encapsulation: ViewEncapsulation.None, template: "<p-dialog [style]=\"{ width: '400px' }\" *ngIf=\"popUpData\" [resizable]=\"false\" [draggable]=\"false\" [visible]=\"popUpData\" [closeOnEscape]=\"false\" [closable]=\"false\" (onHide)=\"buttonAction(2)\">\n  <ng-template pTemplate=\"header\">\n    {{ popUpData.header }}\n  </ng-template>\n\n  <p>{{ popUpData.content }}</p>\n\n\n  <ng-template pTemplate=\"footer\">\n    <ng-container *ngIf=\"popUpData.declineMessage\">\n      <button class=\"whitebutton\" (click)=\"buttonAction(1)\">{{popUpData.declineMessage}}</button>\n    </ng-container>\n    <ng-container *ngIf=\"popUpData.acceptMessage\">\n      <button class=\"btn btn-primary\" (click)=\"buttonAction(0)\">{{popUpData.acceptMessage}}</button>\n    </ng-container>\n  </ng-template>\n\n</p-dialog>\n\n<!-- <p-dialog key=\"idleTimer\" [style]=\"{ width:'400px' }\">\n\n  <ng-template pTemplate=\"content\">\n    <p>{{ timerMsg.data?.sessionActive | replace:{time: (countDown - currentTime) | date:'mm:ss' } }}</p>\n    <p></p>\n  </ng-template>\n\n\n</p-dialog> -->\n", styles: ["p-confirmdialog .p-button-icon.p-button-icon-left.pi{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: NotificationPopUpService }]; } });

class NotificationPopUpModule {
}
NotificationPopUpModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NotificationPopUpModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NotificationPopUpModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NotificationPopUpModule, declarations: [NotificationPopUpComponent], imports: [CommonModule,
        DynamicDialogModule,
        L10nTranslationModule,
        GlobalUtilitiesModule,
        DialogModule], exports: [NotificationPopUpComponent] });
NotificationPopUpModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NotificationPopUpModule, imports: [[
            CommonModule,
            DynamicDialogModule,
            L10nTranslationModule,
            GlobalUtilitiesModule,
            DialogModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NotificationPopUpModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NotificationPopUpComponent
                    ],
                    imports: [
                        CommonModule,
                        DynamicDialogModule,
                        L10nTranslationModule,
                        GlobalUtilitiesModule,
                        DialogModule
                    ],
                    exports: [
                        NotificationPopUpComponent
                    ]
                }]
        }] });

class DateCalendarPickerComponent {
    constructor(locale) {
        this.locale = locale;
        this.componentId = 'NO_COMPONENT_ID';
        this.labelString = 'NO_LABEL_INPUT';
        this.showClear = true;
        this.showButtonBar = false;
        this._secureData = true;
        this.sub = new SubSink();
        this.requiredMap = {
            date: false
        };
    }
    set date(form) {
        var _a;
        this._secureData = (_a = form === null || form === void 0 ? void 0 : form.value) === null || _a === void 0 ? void 0 : _a.includes('*');
        if (form) {
            this._date = form;
        }
        else {
            this._date = new FormControl('');
        }
        this.requiredMap.date = this._date.hasValidator(Validators.required);
        if (this._secureData) {
            this._date.disable();
        }
        this.sub.unsubscribe();
        this.sub.sink = this._date.valueChanges.pipe(distinctUntilChanged())
            .subscribe(date => {
            this._secureData = date === null || date === void 0 ? void 0 : date.includes('*');
            if (this._secureData) {
                this._date.disable();
            }
        });
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
DateCalendarPickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DateCalendarPickerComponent, deps: [{ token: L10N_LOCALE }], target: i0.ɵɵFactoryTarget.Component });
DateCalendarPickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DateCalendarPickerComponent, selector: "lib-calendar-picker", inputs: { componentId: "componentId", labelString: "labelString", showClear: "showClear", showButtonBar: "showButtonBar", date: "date" }, ngImport: i0, template: `
  <ng-container *ngIf="_date">
    <div class="form-group col-md-12"  *ngIf="_secureData; else secureDataTemplate" >
      <label [for]="'dateOfBirth' + componentId" ><span class="required" *ngIf="requiredMap.date">*</span >{{ labelString }}</label>
      <input
          [formControl]="_date"
          type="text"
          [id]="'customDate' + componentId"
          class="dob-inputs form-control"
        />
      <ng-content select="[date]"></ng-content>
    </div>
    <ng-template #secureDataTemplate>
      <div class="form-group col-md-12">
        <label [for]="'customDate' + componentId"><span class="required" *ngIf="requiredMap.date">*</span>{{ labelString }}</label>
        <p-calendar
      placeholder="{{ 'CALENDAR_PLACEHOLDER' | translate: locale.language }}"
      [formControl]="_date"
      [showClear]="showClear"
      [inline]="false"
      [dataType]="'string'"
      [inputId]="'customDate' + componentId"
      [style]="{ 'display': 'block'}"
      [inputStyle]="{'width': '100%'}"
      [showButtonBar]="showButtonBar"
      appendTo="body"
      inputStyleClass="form-control"
      dateMask
      >
    </p-calendar>
        <ng-content select="[date]"></ng-content>
      </div>
    </ng-template>

  </ng-container>
  `, isInline: true, components: [{ type: i1$3.Calendar, selector: "p-calendar", inputs: ["style", "styleClass", "inputStyle", "inputId", "name", "inputStyleClass", "placeholder", "ariaLabelledBy", "iconAriaLabel", "disabled", "dateFormat", "multipleSeparator", "rangeSeparator", "inline", "showOtherMonths", "selectOtherMonths", "showIcon", "icon", "appendTo", "readonlyInput", "shortYearCutoff", "monthNavigator", "yearNavigator", "hourFormat", "timeOnly", "stepHour", "stepMinute", "stepSecond", "showSeconds", "required", "showOnFocus", "showWeek", "showClear", "dataType", "selectionMode", "maxDateCount", "showButtonBar", "todayButtonStyleClass", "clearButtonStyleClass", "autoZIndex", "baseZIndex", "panelStyleClass", "panelStyle", "keepInvalid", "hideOnDateTimeSelect", "touchUI", "timeSeparator", "focusTrap", "showTransitionOptions", "hideTransitionOptions", "tabindex", "view", "defaultDate", "minDate", "maxDate", "disabledDates", "disabledDays", "yearRange", "showTime", "responsiveOptions", "numberOfMonths", "firstDayOfWeek", "locale"], outputs: ["onFocus", "onBlur", "onClose", "onSelect", "onClear", "onInput", "onTodayClick", "onClearClick", "onMonthChange", "onYearChange", "onClickOutside", "onShow"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i4$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i4$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: DateMaskDirective, selector: "[dateMask]" }], pipes: { "translate": i1$1.L10nTranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DateCalendarPickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "lib-calendar-picker",
                    template: `
  <ng-container *ngIf="_date">
    <div class="form-group col-md-12"  *ngIf="_secureData; else secureDataTemplate" >
      <label [for]="'dateOfBirth' + componentId" ><span class="required" *ngIf="requiredMap.date">*</span >{{ labelString }}</label>
      <input
          [formControl]="_date"
          type="text"
          [id]="'customDate' + componentId"
          class="dob-inputs form-control"
        />
      <ng-content select="[date]"></ng-content>
    </div>
    <ng-template #secureDataTemplate>
      <div class="form-group col-md-12">
        <label [for]="'customDate' + componentId"><span class="required" *ngIf="requiredMap.date">*</span>{{ labelString }}</label>
        <p-calendar
      placeholder="{{ 'CALENDAR_PLACEHOLDER' | translate: locale.language }}"
      [formControl]="_date"
      [showClear]="showClear"
      [inline]="false"
      [dataType]="'string'"
      [inputId]="'customDate' + componentId"
      [style]="{ 'display': 'block'}"
      [inputStyle]="{'width': '100%'}"
      [showButtonBar]="showButtonBar"
      appendTo="body"
      inputStyleClass="form-control"
      dateMask
      >
    </p-calendar>
        <ng-content select="[date]"></ng-content>
      </div>
    </ng-template>

  </ng-container>
  `,
                    styles: [],
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [L10N_LOCALE]
                    }] }];
    }, propDecorators: { componentId: [{
                type: Input
            }], labelString: [{
                type: Input
            }], showClear: [{
                type: Input
            }], showButtonBar: [{
                type: Input
            }], date: [{
                type: Input
            }] } });
class DateCalendarPickerModule {
}
DateCalendarPickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DateCalendarPickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DateCalendarPickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DateCalendarPickerModule, declarations: [DateCalendarPickerComponent], imports: [CommonModule,
        ReactiveFormsModule,
        CalendarModule,
        L10nTranslationModule,
        GlobalUtilitiesModule], exports: [DateCalendarPickerComponent] });
DateCalendarPickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DateCalendarPickerModule, imports: [[
            CommonModule,
            ReactiveFormsModule,
            CalendarModule,
            L10nTranslationModule,
            GlobalUtilitiesModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DateCalendarPickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DateCalendarPickerComponent],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        CalendarModule,
                        L10nTranslationModule,
                        GlobalUtilitiesModule
                    ],
                    exports: [DateCalendarPickerComponent],
                }]
        }] });

class LoadSpinnerComponent {
}
LoadSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LoadSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LoadSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: LoadSpinnerComponent, selector: "lib-load-spinner", ngImport: i0, template: `
    <div id="loader-wrapper">
      <div id="loader"></div>
    </div>
    `, isInline: true, styles: ["#loader-wrapper{position:fixed;top:0;left:0;width:100%;height:100%;z-index:2000}#loader{display:block;position:relative;left:50%;top:50%;width:150px;height:150px;margin:-75px 0 0 -75px;border-radius:50%;border:3px solid transparent;border-top-color:#3498db;animation:spin 2s linear infinite}#loader:before{content:\"\";position:absolute;inset:5px;border-radius:50%;border:3px solid transparent;border-top-color:#e74c3c;animation:spin 3s linear infinite}#loader:after{content:\"\";position:absolute;inset:15px;border-radius:50%;border:3px solid transparent;border-top-color:#f9c922;animation:spin 1.5s linear infinite}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LoadSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-load-spinner', template: `
    <div id="loader-wrapper">
      <div id="loader"></div>
    </div>
    `, styles: ["#loader-wrapper{position:fixed;top:0;left:0;width:100%;height:100%;z-index:2000}#loader{display:block;position:relative;left:50%;top:50%;width:150px;height:150px;margin:-75px 0 0 -75px;border-radius:50%;border:3px solid transparent;border-top-color:#3498db;animation:spin 2s linear infinite}#loader:before{content:\"\";position:absolute;inset:5px;border-radius:50%;border:3px solid transparent;border-top-color:#e74c3c;animation:spin 3s linear infinite}#loader:after{content:\"\";position:absolute;inset:15px;border-radius:50%;border:3px solid transparent;border-top-color:#f9c922;animation:spin 1.5s linear infinite}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"] }]
        }] });

class LoadSpinnerService {
    constructor(componentFactoryResolver, appRef, injector, dom) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.dom = dom;
        this.status = false;
    }
    start() {
        if (!this.status) {
            this.status = true;
            this.appendLoadSpinnerComponent();
        }
    }
    stop() {
        if (this.status) {
            this.status = false;
            this.appRef.detachView(this.spinnerRef.hostView);
            this.spinnerRef.destroy();
        }
    }
    appendLoadSpinnerComponent() {
        var _a;
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(LoadSpinnerComponent);
        this.spinnerRef = componentFactory.create(this.injector);
        this.appRef.attachView(this.spinnerRef.hostView);
        const domElem = this.spinnerRef.hostView.rootNodes[0];
        (_a = this.dom.querySelector('body')) === null || _a === void 0 ? void 0 : _a.appendChild(domElem);
    }
}
LoadSpinnerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LoadSpinnerService, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.ApplicationRef }, { token: i0.Injector }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
LoadSpinnerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LoadSpinnerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LoadSpinnerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }, { type: i0.Injector }, { type: Document, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }];
    } });

const LOCALE_BRAND_URL = new InjectionToken('');

class DynamicLocaleLoaderService {
    constructor(backendUrl, httpClient, cookieService, translation) {
        this.backendUrl = backendUrl;
        this.httpClient = httpClient;
        this.cookieService = cookieService;
        this.translation = translation;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadDynamicLocaleConfig(this.backendUrl).catch(rejectMsg => console.log(rejectMsg));
            yield this.translation.init();
        });
    }
    loadDynamicLocaleConfig(backendUrl) {
        return new Promise((resolve, reject) => {
            let config = this.translation['config'];
            let bid = this.cookieService.get('bid');
            let configuredLocales = this.cookieService.getObject('configLocales');
            if (configuredLocales === null || configuredLocales === void 0 ? void 0 : configuredLocales[bid]) {
                Object.assign(this.translation['config'], this.localeToL10nConfig(configuredLocales[bid], config));
                resolve();
            }
            else {
                let brand = bid ? bid : new URL(window.location.href.replace('#', '')).searchParams.get('brand');
                this.httpClient.get(backendUrl + brand).subscribe({
                    next: (response) => {
                        var _a;
                        if (response.error || ((_a = response === null || response === void 0 ? void 0 : response.result) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                            reject('Empty 200 response');
                        }
                        else {
                            this.cookieService.putObject('configLocales', { [bid]: response.result });
                            Object.assign(this.translation['config'], this.localeToL10nConfig(response.result, config));
                            const sessionLocale = JSON.parse(sessionStorage.getItem('locale') || 'null');
                            const defaultLocale = response.result.find(locale => {
                                if (sessionLocale) {
                                    return locale.localeTag === sessionLocale.language;
                                }
                                else {
                                    return locale.defaultLanguage === '1';
                                }
                            });
                            this.translation.setLocale({
                                language: (defaultLocale === null || defaultLocale === void 0 ? void 0 : defaultLocale.localeTag) || 'en-US',
                                currency: (defaultLocale === null || defaultLocale === void 0 ? void 0 : defaultLocale.currency) || 'USD'
                            });
                            resolve();
                        }
                    },
                    error: (err) => reject('Service call error. Maintaining default configuration')
                });
            }
        });
    }
    localeToL10nConfig(locales, config) {
        const defaultLang = locales.find(locale => locale.defaultLanguage);
        return Object.assign(Object.assign({}, config), { defaultLocale: { language: defaultLang.localeTag, currency: defaultLang === null || defaultLang === void 0 ? void 0 : defaultLang.currency }, schema: locales.map(loc => {
                return {
                    locale: {
                        language: loc.localeTag,
                        currency: loc.currency
                    },
                    dir: 'ltr',
                    text: loc.displayName
                };
            }) });
    }
}
DynamicLocaleLoaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicLocaleLoaderService, deps: [{ token: LOCALE_BRAND_URL }, { token: i1$4.HttpClient }, { token: i2$3.CookieService }, { token: i1$1.L10nTranslationService }], target: i0.ɵɵFactoryTarget.Injectable });
DynamicLocaleLoaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicLocaleLoaderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicLocaleLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [LOCALE_BRAND_URL]
                    }] }, { type: i1$4.HttpClient }, { type: i2$3.CookieService }, { type: i1$1.L10nTranslationService }];
    } });

/*
 * Public API Surface of leasing-source-shared
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ADDRESS_ENDPOINT, AddressToStringPipe, ClearNullPipe, DYNAMIC_L10N_API_ENDPOINT, DataTableComponent, DataTableModule, DateCalendarPickerComponent, DateCalendarPickerModule, DateMaskDirective, DynamicLocaleLoaderService, DynamicTranslationModule, ForceUppercaseDirective, GlobalUtilitiesModule, L10nStorageService, LOCALE_BRAND_URL, LoadSpinnerService, NotificationPopUpComponent, NotificationPopUpModule, NotificationPopUpService, PreventDoubleClicksDirective, ProperNamePipe, ReplacePipe, RetrieveTranslate, SafeHtmlPipe, SmartAddressComponent, SmartAddressModule, SmartAddressService, SmartAddressServiceAbstract, SubDividerComponent, SubDividerModule, TranslateTxtInputDirective, UI_LABEL_PREFIX, YNtoStringPipe, kvTranslate, lib_i18nAssets };
